import { enumCounterpartyGroupSortOption } from '@rematter/frontend-lib-api-client';

import { createEntitySelect } from './helpers/createEntitySelect';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

const counterpartyGroupsForSelectQueryAtom = createQueryAtomFactory(
  'shared.selectCounterpartyGroup',
  () => ({
    counterpartyGroups: {
      __args: {
        sorting: [enumCounterpartyGroupSortOption.NameAsc],
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        operationType: true,
      },
    },
  }),
  {
    select: (data) => data?.counterpartyGroups?.entries ?? [],
  },
);

export const SelectCounterpartyGroup = createEntitySelect(
  'SelectCounterpartyGroup',
  counterpartyGroupsForSelectQueryAtom,
  {
    formatLabel: (entity) => entity.name,
    formatSubLabel: (entity) => entity.operationType,
  },
);
